export const UPDATE_SECOES = 'UPDATE_SECOES';
export const ADD_SECOES = 'ADD_SECOES';
export const SET_SECOES = 'SET_SECOES';
export const REMOVE_SECOES = 'REMOVE_SECOES';
export const SET_SECAO = 'SET_SECAO';